import { render, staticRenderFns } from "./DashboardFeedback.vue?vue&type=template&id=7a08db02&scoped=true&"
import script from "./DashboardFeedback.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedback.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedback.vue?vue&type=style&index=0&id=7a08db02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a08db02",
  null
  
)

export default component.exports